import { defineComponent as _defineComponent } from 'vue';
import { BButton } from "bootstrap-vue";
import {} from "@/api";
import ObjectStoreBadges from "@/components/ObjectStore/ObjectStoreBadges.vue";
import ProvidedQuotaSourceUsageBar from "@/components/User/DiskUsage/Quota/ProvidedQuotaSourceUsageBar.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ObjectStoreSelectButton',
    props: {
        objectStore: null,
        variant: null,
        idPrefix: null
    },
    emits: ["click"],
    setup(__props, { emit }) {
        return { __sfc: true, emit, BButton, ObjectStoreBadges, ProvidedQuotaSourceUsageBar };
    }
});
